<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div class="card_container" style="flex: 0 0 20%">
          <div class="row align-items-center fuel_consumption_buttons_row">
            <div class="col-md-12 fuel_consumption_btn_div mt-3">
              <div
                class="fuel_consumption_button active_tab"
                style="height: 80px; width: 80px"
              >
                <h3 class="text-white">{{ productSummaryCount }}</h3>
              </div>
              <div class="text-center voucher_type mt-2 primary_text">
                {{ $t("text.productSummary.totalTransactions") }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuel_consumption_row_right_section mr-3 vr__bg"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center" style="height: 100%">
            <div class="col-md-6">
              <div
                class="transaction_period_text text-center branch__sales__text"
                style="font-size: 22px"
              >
                {{ $t("text.productSummary.title") }}
              </div>
            </div>
            <div class="col-md-4 drop_down_input_group">
              <div class="drop_down_section mt-2 mr-2">
                <div class="drop_down_div align-items-center">
                  <vue-ctk-date-time-picker
                    v-model="dateRange"
                    :max-date="maxDate"
                    :range="true"
                    :autoClose="true"
                    :locale="this.$root.$i18n.locale"
                    :custom-shortcuts="customShortcuts"
                    :color="$store.getters.getDatePickerColor"
                    format="DDMMYYYY"
                    formatted="DD/MM/YYYY"
                    :label="$t('text.calendar.dateRange')"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="row dashboard_first_row mt-3">
        <!-- PMS SECTION -->
        <section class="col-md-4 card_row" :class="productCount" v-if="hasPms">
          <div class="card_container_1 dashboard_card_1 mt-3">
            <div class="clearfix">
              <div class="left_div">
                <h4 class="stations_card_header">
                  {{ countryProducts.products.product1 }}
                </h4>
              </div>
              <div class="right_div">
                <h4 class="stations_card_header">
                  {{ decimalThousand(pmsSummary.volume) }}
                </h4>
              </div>
            </div>
            <div class="row dashboard_card mt-2">
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="oil_drop_div_1">
                  <div class="text-center">
                    <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                  </div>
                </div>
              </div>
              <div class="col-lg-9 col-md-9 col-sm-4 text-right"></div>
            </div>
            <div class="row dashboard_card mt-3">
              <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
              <div class="col-lg-8 col-md-8 col-sm-4 text-right">
                <h4 class="dashboard__footer__amount" style="font-size: 23px">
                  {{ branch ? branch.currencyCode : "" }}
                  {{ decimalThousand(pmsSummary.amount) }}
                  <!-- {{ $n(pmsSummary.amount, "currency") }} -->
                </h4>
              </div>
            </div>
          </div>
        </section>
        <section class="col-md-4 card_row" :class="productCount" v-if="hasAgo">
          <div class="card_container_1 dashboard_card_1 mt-3">
            <div class="clearfix">
              <div class="left_div">
                <h4 class="stations_card_header_1">
                  {{ countryProducts.products.product2 }}
                </h4>
              </div>
              <div class="right_div">
                <h4 class="stations_card_header_1">
                  {{ decimalThousand(agoSummary.volume) }}
                </h4>
              </div>
            </div>
            <div class="row dashboard_card mt-2">
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="oil_drop_div_2">
                  <div class="text-center">
                    <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                  </div>
                </div>
              </div>
              <div class="col-lg-9 col-md-9 col-sm-4 text-right"></div>
            </div>
            <div class="row dashboard_card mt-3">
              <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
              <div class="col-lg-8 col-md-8 col-sm-4 text-right">
                <h4 class="dashboard__footer__amount_1" style="font-size: 23px">
                  {{ branch ? branch.currencyCode : "" }}
                  {{ decimalThousand(agoSummary.amount) }}
                  <!-- {{ $n(agoSummary.amount, "currency") }} -->
                </h4>
              </div>
            </div>
          </div>
        </section>
        <section class="col-md-4 card_row" :class="productCount" v-if="hasDpk">
          <div class="card_container_1 dashboard_card_1 mt-3">
            <div class="clearfix">
              <div class="left_div">
                <h4 class="stations_card_header_2">
                  {{ countryProducts.products.product3 }}
                </h4>
              </div>
              <div class="right_div">
                <h4 class="stations_card_amount_header_3">
                  {{ decimalThousand(dpkSummary.volume) }}
                </h4>
              </div>
            </div>
            <div class="row dashboard_card mt-2">
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="oil_drop_div_3">
                  <div class="text-center">
                    <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                  </div>
                </div>
              </div>
              <div class="col-lg-8 col-md-8 col-sm-4 text-right"></div>
            </div>
            <div class="row dashboard_card mt-3">
              <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
              <div class="col-lg-8 col-md-9 col-sm-8 text-right">
                <h4 class="dashboard__footer__amount_2" style="font-size: 23px">
                  <!-- {{ $n(dpkSummary.amount, "currency") }} -->
                  {{ branch ? branch.currencyCode : "" }}
                  {{ decimalThousand(dpkSummary.amount) }}
                </h4>
              </div>
            </div>
          </div>
        </section>
        <section class="col-md-4 card_row" :class="productCount" v-if="hasLpg">
          <div class="card_container_1 dashboard_card_1 mt-3">
            <div class="clearfix">
              <div class="left_div">
                <h4 class="stations_card_header_1" style="color: purple">
                  {{ countryProducts.products.product4 }}
                </h4>
              </div>
              <div class="right_div">
                <h4 class="stations_card_header_1" style="color: purple">
                  {{ decimalThousand(lpgSummary.volume) }}
                </h4>
              </div>
            </div>
            <div class="row dashboard_card mt-2">
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="oil_drop_div_2" style="background: purple">
                  <div class="text-center">
                    <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                  </div>
                </div>
              </div>
              <div class="col-lg-9 col-md-9 col-sm-4 text-right"></div>
            </div>
            <div class="row dashboard_card mt-3">
              <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
              <div class="col-lg-8 col-md-8 col-sm-4 text-right">
                <h4
                  class="dashboard__footer__amount_1"
                  style="font-size: 23px; color: purple"
                >
                  <!-- {{ $n(lpgSummary.amount, "currency") }} -->
                  {{ branch ? branch.currencyCode : "" }}
                  {{ decimalThousand(lpgSummary.amount) }}
                </h4>
              </div>
            </div>
          </div>
        </section>
        <section class="col-md-4 card_row" :class="productCount">
          <div class="card_container_1 dashboard_card_1 mt-3">
            <div class="clearfix">
              <div class="left_div">
                <h4 class="stations_card_header_3">
                  {{ $t("text.productSummary.total") }}
                </h4>
              </div>
              <div class="right_div">
                <h4 class="stations_card_amount_header_4">
                  {{
                    decimalThousand(
                      pmsSummary.volume +
                        agoSummary.volume +
                        dpkSummary.volume +
                        lpgSummary.volume
                    )
                  }}
                </h4>
              </div>
            </div>
            <div class="row dashboard_card mt-2">
              <div class="col-lg-3 col-md-3 col-sm-12">
                <div class="oil_drop_div_4">
                  <div class="text-center">
                    <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                  </div>
                </div>
              </div>
              <div class="col-lg-8 col-md-8 col-sm-4 text-right"></div>
            </div>
            <div class="row dashboard_card mt-3">
              <div class="col-lg-4 col-md-4 col-sm-12 percent__column"></div>
              <div class="col-lg-8 col-md-8 col-sm-4 text-right">
                <h4 class="dashboard__footer__amount_3" style="font-size: 23px">
                  {{ branch ? branch.currencyCode : "" }}
                  {{
                    decimalThousand(
                      pmsSummary.amount +
                        agoSummary.amount +
                        dpkSummary.amount +
                        lpgSummary.amount
                    )
                  }}
                  <!-- {{
                    $n(
                      pmsSummary.amount +
                        agoSummary.amount +
                        dpkSummary.amount +
                        lpgSummary.amount,
                      "currency"
                    )
                  }} -->
                </h4>
              </div>
            </div>
          </div>
        </section>
      </section>
      <div class="section__row mt-3">
        <section>
          <div class="mt-3">
            <div class="">
              <div class="row top_section_row">
                <div class="col-md-8">
                  <span class="sec_text_color">
                    <img src="@/assets/img/hand (1).png" class="mr-3" />
                    {{ $t("text.productSummary.transBtw") }}
                    {{
                      $d(new Date(startDate), "short", this.$root.$i18n.locale)
                    }}
                    {{ $t("text.and.text") }}
                    {{
                      $d(new Date(endDate), "short", this.$root.$i18n.locale)
                    }}
                  </span>
                </div>
                <div class="col-md-4 text-right"></div>
              </div>
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :dataBound="dataBound"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :excelQueryCellInfo="excelQueryCellInfo"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column width="40" field="index" headerText="#"></e-column>
                  <!-- <e-column field="date" width="200" :headerText="$t('text.productSummary.date')" :sortComparer='sortComparer'></e-column> -->
                  <e-column
                    field="date"
                    width="200"
                    :headerText="$t('text.productSummary.date')"
                    type="date"
                    :format="formatOptions"
                  ></e-column>
                  <e-column
                    :visible="isPMS !== undefined"
                    field="pmsVolume"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product1} ${$t(
                      'text.productSummary.productVolume'
                    )}`"
                  ></e-column>
                  <e-column
                    :visible="isPMS !== undefined"
                    field="pmsAmount"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product1} ${$t(
                      'text.productSummary.productAmount',
                      { currency: `(${branch ? branch.currency : ''})` }
                    )}`"
                  ></e-column>
                  <e-column
                    :visible="isAGO !== undefined"
                    field="agoVolume"
                    format="N2"
                    width="200"
                    :headerText="`${countryProducts.products.product2} ${$t(
                      'text.productSummary.productVolume'
                    )}`"
                  ></e-column>
                  <e-column
                    :visible="isAGO !== undefined"
                    field="agoAmount"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product2} ${$t(
                      'text.productSummary.productAmount',
                      { currency: `(${branch ? branch.currency : ''})` }
                    )}`"
                  ></e-column>
                  <e-column
                    :visible="isDPK !== undefined"
                    field="dpkVolume"
                    format="N2"
                    width="200"
                    :headerText="`${countryProducts.products.product3} ${$t(
                      'text.productSummary.productVolume'
                    )}`"
                  ></e-column>
                  <e-column
                    :visible="isDPK !== undefined"
                    field="dpkAmount"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product3} ${$t(
                      'text.productSummary.productAmount',
                      { currency: `(${branch ? branch.currency : ''})` }
                    )}`"
                  ></e-column>
                  <e-column
                    :visible="isLPG !== undefined"
                    field="lpgVolume"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product4} ${$t(
                      'text.productSummary.productVolume'
                    )}`"
                  ></e-column>
                  <e-column
                    :visible="isLPG !== undefined"
                    field="lpgAmount"
                    width="200"
                    format="N2"
                    :headerText="`${countryProducts.products.product4} ${$t(
                      'text.productSummary.productAmount',
                      { currency: `(${branch ? branch.currency : ''})` }
                    )}`"
                  ></e-column>
                  <e-column
                    field="totalAmount"
                    width="200"
                    format="N2"
                    :headerText="$t('text.productSummary.totalAmount')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </section>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import countryProducts from "@/products";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";

let $ = JQuery;

export default {
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      isPMS: false,
      isAGO: false,
      isDPK: false,
      isLPG: false,
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      transFilter: "Show All",
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      backgroundUrl,
      branch: {},
      branchId: null,
      hasLpg: false,
      hasPms: false,
      hasAgo: false,
      hasDpk: false,
      productCount: "col-lg-3",
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      branches: 0,
      dealers: 0,
      showLoader: false,
      showAll: false,
      lowTanks: [],
      pmsRate: 0,
      agoRate: 0,
      dpkRate: 0,
      lpgRate: 0,
      groupArrays: [{}],
      productSummary: [],
      pmsSummary: { volume: 0, amount: 0 },
      agoSummary: { volume: 0, amount: 0 },
      dpkSummary: { volume: 0, amount: 0 },
      lpgSummary: { volume: 0, amount: 0 },
      productSummaryCount: 0,
    };
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getProductSummary();
        this.getSalesTransaction();
      }
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        if (this.$route.query.branchId) {
          this.branchId = this.branch.id;
          if (this.branchId !== null) {
            this.getProductSummary();
            this.getSalesTransaction();
          }
        } else {
          if (this.branch.id) {
            this.branchId = this.branch.id;
          }
          if (this.branchId !== null) {
            this.getProductSummary();
            this.getSalesTransaction();
          }
        }
      }
    },
  },
  created() {
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
    document.title = `Product Summary:: Epump Retail Outlet`;
    this.showLoader = true;
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Product Summary:: ${branch.name} Retail Outlet`;
    });
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  beforeDestroy() {},
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    revertNumber(number) {
      return Number(number.replace(/[^0-9.]+/g, ""));
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    changeRoute(route) {
      this.$router.push({ name: route });
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    displayProductSummary(productSummary) {
      let prodCount = 0;
      let summary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product1
      );
      if (summary.length) {
        this.pmsSummary = {
          amount: summary.reduce((acc, curr) => {
            return acc + curr.amount;
          }, 0),
          volume: summary.reduce((acc, curr) => {
            return acc + curr.volume;
          }, 0),
        };
        this.hasPms = true;
        prodCount++;
      }

      summary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product2
      );
      if (summary.length) {
        this.agoSummary = {
          amount: summary.reduce((acc, curr) => {
            return acc + curr.amount;
          }, 0),
          volume: summary.reduce((acc, curr) => {
            return acc + curr.volume;
          }, 0),
        };
        this.hasAgo = true;
        prodCount++;
      }

      summary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product3
      );
      if (summary.length) {
        this.dpkSummary = {
          amount: summary.reduce((acc, curr) => {
            return acc + curr.amount;
          }, 0),
          volume: summary.reduce((acc, curr) => {
            return acc + curr.volume;
          }, 0),
        };
        this.hasDpk = true;
        prodCount++;
      }

      summary = productSummary.filter(
        (prod) =>
          prod.product.toLowerCase() ==
          this.countryProducts.productsLower.product4
      );
      if (summary.length) {
        this.lpgSummary = {
          amount: summary.reduce((acc, curr) => {
            return acc + curr.amount;
          }, 0),
          volume: summary.reduce((acc, curr) => {
            return acc + curr.volume;
          }, 0),
        };
        this.hasLpg = true;
        prodCount++;
      }
      prodCount++;
      let columnNumber;
      prodCount !== 5 ? (columnNumber = 12 / prodCount) : (columnNumber = 3);
      this.productCount = `col-lg-${columnNumber}`;
    },
    getProductSummary() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/DaySale/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.productSummary = response.data;
          this.displayProductSummary(response.data);
        })
        .catch((error) => {});
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    getSalesTransaction() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Sales/${this.branchId}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          // this.productSummaryCount = response.data.totalTransactions;

          const groups = response.data.transactions.reduce((group, sales) => {
            const date = sales.date.split("T")[0];
            if (!group[date]) {
              group[date] = [];
            }
            group[date].push(sales);
            return group;
          }, {});
          let count = 0;
          let _this = this;
          const groupArrays = Object.keys(groups).map((date) => {
            let pmsCheck = groups[date].filter(
              (sl) =>
                sl.productName !== null &&
                sl.productName.toLowerCase() ===
                  this.countryProducts.productsLower.product1
            );

            let agoCheck = groups[date].filter(
              (sl) =>
                sl.productName !== null &&
                sl.productName.toLowerCase() ===
                  this.countryProducts.productsLower.product2
            );
            let dpkCheck = groups[date].filter(
              (sl) =>
                sl.productName == this.countryProducts.productsLower.product3 ||
                sl.pumpName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product3) ||
                sl.productName == this.countryProducts.products.product3
            );
            let lpgCheck = groups[date].filter(
              (sl) =>
                sl.productName == this.countryProducts.productsLower.product4 ||
                sl.pumpName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product4) ||
                sl.productName == this.countryProducts.products.product4
            );
            return {
              index: ++count,
              date,
              pmsVolume: pmsCheck.length
                ? pmsCheck.reduce((acc, currValue) => {
                    return acc + currValue.volumeSold;
                  }, 0)
                : null,
              pmsAmount: pmsCheck.length
                ? pmsCheck.reduce((acc, currValue) => {
                    return acc + currValue.amountSold;
                  }, 0)
                : null,
              agoVolume: agoCheck.length
                ? agoCheck.reduce((acc, currValue) => {
                    return acc + currValue.volumeSold;
                  }, 0)
                : null,
              agoAmount: agoCheck.length
                ? agoCheck.reduce((acc, currValue) => {
                    return acc + currValue.amountSold;
                  }, 0)
                : null,
              dpkVolume: dpkCheck.length
                ? dpkCheck.reduce((acc, currValue) => {
                    return acc + currValue.volumeSold;
                  }, 0)
                : null,
              dpkAmount: dpkCheck.length
                ? dpkCheck.reduce((acc, currValue) => {
                    return acc + currValue.amountSold;
                  }, 0)
                : null,
              lpgVolume: lpgCheck.length
                ? lpgCheck.reduce((acc, currValue) => {
                    return acc + currValue.volumeSold;
                  }, 0)
                : null,
              lpgAmount: lpgCheck.length
                ? lpgCheck.reduce((acc, currValue) => {
                    return acc + currValue.amountSold;
                  }, 0)
                : null,
              totalAmount: groups[date].reduce((acc, currValue) => {
                return acc + currValue.amountSold;
              }, 0),
            };
          });

          this.isPMS = groupArrays.find((item) => item.pmsAmount > 0);
          this.isAGO = groupArrays.find((item) => item.agoAmount > 0);
          this.isDPK = groupArrays.find((item) => item.dpkAmount > 0);
          this.isLPG = groupArrays.find((item) => item.lpgAmount > 0);

          for (var i of groupArrays) {
            for (var u in i) {
              if (i[u] == null) {
                delete i[u];
              }
            }
          }

          this.productSummaryCount = groupArrays.length;
          this.groupArrays = groupArrays;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: groupArrays,
          });
          const testAmount = groupArrays.reduce((prev, cur) => {
            return prev + cur.pmsAmount;
          }, 0);
          const testVolume = groupArrays.reduce((prev, cur) => {
            return prev + cur.pmsVolume;
          }, 0);

          this.refreshGrid();
        })
        .catch((error) => {});
    },
    decimalThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
